import React, { useMemo } from 'react';
import RankedBars from './RankedBars';
import { fmt, fmtPercent } from '../format';
import { getSalesAmount, sum } from '../salesCalculations';
import { cardStyle } from '../styles';

const TOP_COUNT = 20;

// Invoice count followed by the distinct "our reference" names on the customer's invoices
const getSublabel = (row) => {
    const references = [...new Set(row.invoices.map((i) => i.ourReference).filter(Boolean))];
    return [`${row.count} fakturor`, ...references].join(' · ');
};

// Largest customers by amount (net + freight); web invoices are excluded since they are consumers, not named customers
const TopCustomers = ({ invoices, onShowInvoices }) => {
    const { rows, total } = useMemo(() => {
        const byCustomer = new Map();
        invoices.filter((i) => !i.isWeb).forEach((invoice) => {
            const key = invoice.customerNumber || invoice.customerName || 'unknown';
            const entry = byCustomer.get(key) || { key, label: invoice.customerName || key, value: 0, count: 0, invoices: [] };
            entry.value += getSalesAmount(invoice);
            entry.count += 1;
            entry.invoices.push(invoice);
            byCustomer.set(key, entry);
        });

        const all = [...byCustomer.values()];
        return { rows: all.sort((a, b) => b.value - a.value).slice(0, TOP_COUNT), total: sum(all.map((e) => e.value)) };
    }, [invoices]);

    return (
        <div style={{ ...cardStyle, padding: '1rem' }}>
            <strong>St&ouml;rsta kunder</strong>
            <div style={{ fontSize: '0.75rem', color: '#777', margin: '0.25rem 0 0.75rem' }}>
                Netto + frakt exklusive webbfakturor. Andel av f&ouml;rs&auml;ljningen utanf&ouml;r webben.
            </div>
            <RankedBars
                rows={rows.map((row) => ({
                    key: row.key,
                    label: row.label,
                    sublabel: getSublabel(row),
                    value: row.value,
                    valueLabel: `${fmt(row.value)} (${fmtPercent(total > 0 ? row.value / total : 0)})`,
                    onClick: () => onShowInvoices({ title: row.label, invoices: row.invoices }),
                }))}
            />
        </div>
    );
};

export default TopCustomers;
